const features = [
  { icon: 'ri-time-line', title: 'Same-Day Appointments', desc: 'Urgent concerns are seen the same day. No long waits, no runaround.' },
  { icon: 'ri-team-line', title: 'Dedicated Care Team', desc: 'Your personal care team knows your history and coordinates every aspect of your health.' },
  { icon: 'ri-shield-check-line', title: 'Medicare & Most Insurance', desc: 'We accept Medicare Advantage, Medicaid, and most major commercial insurance plans.' },
  { icon: 'ri-translate-2', title: 'Multilingual Staff', desc: 'Our team speaks English, Spanish, and Mandarin to serve our diverse community.' },
];

export default function WhyChooseUs() {
  return (
    <section className="bg-white overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[700px]">
        {/* Left — Image */}
        <div className="relative h-[400px] lg:h-auto">
          <img
            src="https://public.readdy.ai/ai/img_res/0f0beb9b3fce1a924a4bd49ae20988e2.jpg"
            alt="AxisPoint Medical care team"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute bottom-8 right-8 bg-zinc-950 text-white rounded-2xl p-6 max-w-[220px]">
            <div
              className="text-4xl font-black text-rose-400 mb-1"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              4.9
            </div>
            <div className="flex gap-0.5 mb-2">
              {[1,2,3,4,5].map(i => (
                <i key={i} className="ri-star-fill text-rose-400 text-xs"></i>
              ))}
            </div>
            <div className="text-zinc-400 text-xs">Based on 1,200+ patient reviews</div>
          </div>
        </div>

        {/* Right — Content */}
        <div className="flex flex-col justify-center px-8 md:px-16 py-20 bg-zinc-950">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-px bg-rose-500"></div>
            <span className="text-rose-400 text-xs font-semibold uppercase tracking-[0.25em]">Why AxisPoint</span>
          </div>
          <h2
            className="text-4xl md:text-5xl font-black text-white leading-tight mb-8"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            Care That Goes<br />Beyond the<br />Exam Room
          </h2>
          <p className="text-zinc-400 text-sm leading-relaxed mb-12 max-w-md">
            At AxisPoint Medical, we believe great healthcare is built on relationships. Our physicians take the time to truly listen, understand your goals, and create personalized care plans that fit your life.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {features.map((f) => (
              <div key={f.title} className="flex gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-zinc-800 shrink-0">
                  <i className={`${f.icon} text-rose-400 text-base`}></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold text-sm mb-1">{f.title}</h4>
                  <p className="text-zinc-500 text-xs leading-relaxed">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
